/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Unsaved_ChangesInputs */

const cs_workflow_unsaved_changes = /** @type {(inputs: Workflow_Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuložené změny`)
};

const en_workflow_unsaved_changes = /** @type {(inputs: Workflow_Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved changes`)
};

/**
* | output |
* | --- |
* | "Unsaved changes" |
*
* @param {Workflow_Unsaved_ChangesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_unsaved_changes = /** @type {((inputs?: Workflow_Unsaved_ChangesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Unsaved_ChangesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_unsaved_changes(inputs)
	return cs_workflow_unsaved_changes(inputs)
});